import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation ReleaseWave($input: ReleaseWaveInput!) {
    releaseWave(input: $input) {
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/releaseWave.js